import styled, { css } from 'styled-components';
import { Tag } from '@rainbow-modules/icons';
import BadgeOverlay from 'react-rainbow-components/components/BadgeOverlay';
import DatePickerFilter from 'components/DatePickerFilter';
import { StyledPickList } from 'components/DatePickerFilter/styled';
import NumericFilter from 'components/NumericFilter';
import CallFlagsFilter from 'components/CallFlagsFilter';
import CallTypeFilter from 'components/CallTypeFilter';
import CallStatusFilter from 'components/CallStatusFilter';
import CallAnsweredBySelect from 'components/CallAnsweredBySelect';
import EntityTagsFilter from 'components/EntityTagsFilter';
import Clock from 'components/icons/clock';
import { color } from 'theme';
import { PURPLE_100, PURPLE_500 } from '../../../constants';

export const FilterButtonDropDown = styled.div`
    width: 21.25rem;
    overflow: hidden;
    height: 100%;
    border-radius: 1rem;
    display:flex;
    flex-direction: column;
    align-items: flex-start;
    background: ${color('background.main')};
    box-shadow: 0px var(--Primitives-Number-scale-4, 4px) var(--Primitives-Number-scale-4, 4px) 0px rgba(0, 0, 0, 0.06), 0px var(--Primitives-Number-scale-8, 8px) var(--Primitives-Number-scale-24, 24px) 0px rgba(75, 70, 92, 0.16);
    transition: opacity 0.1s linear, visibility 0.1s linear;

    &:focus,
    &:active {
        outline: none;
    }             
`;

export const StyledBadgeOverlay = styled(BadgeOverlay)`
    ${(props) => props.variant === 'brand' && css`
        & > span {
            background: ${PURPLE_100};
            color: ${PURPLE_500};
        }
    `};
`;

export const StyledPicklist = styled(StyledPickList)`
    width: unset;
    flex: 1;
    margin: 0 0.5rem 0 2.5rem;
`;

export const TagIcon = styled(Tag)`
    width: 1.25rem !important;
    height: 1.25rem !important;
`;

export const ClockIcon = styled(Clock)`
    width: 1.25rem !important;
    height: 1.25rem !important;
`;

export const StyledDatePickerFilter = styled(DatePickerFilter)`
    width: unset;
    flex: 1;
    margin: 0 0.5rem 0 2.5rem;
`;

export const DurationFilter = styled(NumericFilter)`
    padding: 0rem 0.5rem 0rem 2.5rem;
`;

export const StyledCallTypeFilter = styled(CallTypeFilter)`
    width: unset;
    flex: 1;
    margin: 0 0.5rem 0 2.5rem;
`;

export const StyledCallStatusFilter = styled(CallStatusFilter)`
    padding-left: 2.5rem;
`;

export const StyledCallFlagsFilter = styled(CallFlagsFilter)`
    padding-left: 2.5rem;
`;

export const StyledCallTagsFilter = styled(EntityTagsFilter)`
    padding-left: 2.5rem;
`;

export const StyledCallAnsweredBySelect = styled(CallAnsweredBySelect)`
    padding-left: 2.5rem;

    > div {
        gap: 0.25rem;
    }
`;
